import { MeterAlarmDefinitionsController } from "./meter-alarm-def.controller"
import { GRID_SERVICE_NAME } from "../../../services/grid"
import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"

export const COMPONENT_NAME: string = 'meterAlarmDefinitions'

import * as TEMPLATE from './meter-alarm-def.tpl.html'

export class MeterAlarmDefinitionsComponent {

    controller = ['api', '$element', GRID_SERVICE_NAME, 'localDictionary', USER_SESSION_SERVICE_NAME, MeterAlarmDefinitionsController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}